import { useSyncExternalStore } from 'react';
import { shareStore, type ShareUiState } from './shareService.js';

const INITIAL: ShareUiState = { active: false, id: null, expiresAt: null, boatName: null };

/** Reactive view of the module-level shareStore (spec 15) — used by the
 *  DELER chip and the share sheet. */
export function useShareState(): ShareUiState {
  return useSyncExternalStore(
    shareStore.subscribe,
    () => shareStore.getState(),
    () => INITIAL,
  );
}
